<template>
  <div class="shoppe">
    <div class="query-form">
      <el-form label-position="right" label-width="80px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="24" :lg="20" :xl="20">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="退税公司名称" label-width="100px">
                  <el-select v-model="queryForm.merchantTaxRefundCompanyId" filterable clearable style="width: 100%">
                    <el-option v-for="item in taxRefundCompanyList" :key="item.merchantTaxRefundCompanyId" :value="item.merchantTaxRefundCompanyId" :label="item.taxRefundCompanyName"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="国家">
                  <el-select v-model="queryForm.addressCountryId" filterable clearable style="width: 100%">
                    <el-option v-for="item in countryList" :key="item.value" :value="item.value" :label="item.label"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="退税比例">
                  <input-range v-model="taxRefundRatioRange"></input-range>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12" :lg="8" :xl="6">
                <el-form-item label="手续费比例" label-width="90px">
                  <input-range symbol="%" v-model="handleFeeRatioRange"></input-range>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="4" :xl="4">
            <el-button @click="search" type="primary">查询</el-button>
            <el-button @click="reset">重置</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="tr">
      <el-button type="primary" @click="showCreate">创建</el-button>
    </div>
    <el-table :data="tableData">
      <el-table-column prop="merchantTaxRefundCompanyId" label="ID"></el-table-column>
      <el-table-column prop="taxRefundCompanyName" label="退税公司名称"></el-table-column>
      <el-table-column prop="addressCountryName" label="国家"></el-table-column>
      <el-table-column prop="taxRefundRatio" label="退税比例"></el-table-column>
      <el-table-column label="手续费比例">
        <template slot-scope="scope">
          {{ scope.row.handleFeeRatio != null ? scope.row.handleFeeRatio + '%' : '' }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-link type="primary" @click="editItem(scope.row)">修改配置</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>

    <el-dialog append-to-body :title="form.merchantTaxRefundCompanyId ? '编辑' : '创建'" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false">
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item prop="taxRefundCompanyName" label="退税公司名称" :rules="[{ required: true, message: '请输入退税公司名称' }]">
          <el-input v-model="form.taxRefundCompanyName" :maxlength="100"></el-input>
        </el-form-item>
        <el-form-item prop="addressCountryId" label="国家" :rules="[{ required: true, message: '请选择国家' }]">
          <el-select v-model="form.addressCountryId" filterable>
            <el-option v-for="item in countryList" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="taxRefundRatio" label="退税比例" :rules="[{ required: true, message: '请输入退税比例' }, { validator: valiTaxRefundRatio, trigger: 'blur' }]">
          <el-input v-model="form.taxRefundRatio" :maxlength="6"></el-input>
        </el-form-item>
        <el-form-item prop="handleFeeRatio" label="手续费比例" :rules="[{ required: true, message: '请输入手续费比例' }, { validator: valiTaxRefundRatio, trigger: 'blur' }]">
          <el-input v-model="form.handleFeeRatio" :maxlength="6">
            <i slot="suffix" class="el-input__icon">%</i>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">{{ form.merchantTaxRefundCompanyId ? '提交' : '创建' }}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import {
  getTaxRefundCompanyList,
  getMerchantTaxRefundCompanyList,
  createOrUpdateTaxRefundCompany,
} from "../../api/merchants";
import {
  getCountryList,
} from '../buyershop/api';
import InputRange from './InputRange.vue';

export default {
  components: {
    InputRange,
  },
  data() {
    return {
      taxRefundCompanyList: [],
      taxRefundRatioRange: [],
      handleFeeRatioRange: [],
      queryForm: {
        merchantTaxRefundCompanyId: null,
        addressCountryId: null,
        pageNo: 1,
        pageSize: 25,
      },
      countryList: [],
      tableData: [],
      total: 0,
      dialogVisible: false,
      form: {
        merchantTaxRefundCompanyId: null,
        taxRefundCompanyName: null,
        addressCountryId: null,
        taxRefundRatio: 1,
        handleFeeRatio: 0,
      },
    };
  },
  mounted() {
    getMerchantTaxRefundCompanyList().then(res => {
      this.taxRefundCompanyList = res.data.data || [];
    })
    getCountryList().then(res=>{
      this.countryList = (res.data.data || []).map(item => {
        return {
          value: item.addressCountryId,
          label: item.name
        }
      })
    })
    this.getTableData();
  },
  methods: {
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.merchantTaxRefundCompanyId = null;
      this.queryForm.addressCountryId = null;
      this.taxRefundRatioRange = [];
      this.handleFeeRatioRange = [];
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      getTaxRefundCompanyList({
        ...this.queryForm,
        taxRefundRatioStart: this.taxRefundRatioRange[0],
        taxRefundRatioEnd: this.taxRefundRatioRange[1],
        handleFeeRatioStart: this.handleFeeRatioRange[0],
        handleFeeRatioEnd: this.handleFeeRatioRange[1],
      }).then(res => {
        if (res.data && res.data.data) {
          this.total = res.data.data.total;
          this.tableData = res.data.data.list;
        }
      })
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    showCreate() {
      this.form.merchantTaxRefundCompanyId = null;
      this.form.taxRefundCompanyName = null;
      this.form.addressCountryId = null;
      this.form.taxRefundRatio = 1;
      this.form.handleFeeRatio = 0;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      })
    },
    editItem(row) {
      this.form = JSON.parse(JSON.stringify(row));
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      })
    },
    submit() {
      if (this.repeatSave) {
        return;
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.repeatSave) {
            return;
          }
          this.repeatSave = true;
          createOrUpdateTaxRefundCompany(this.form).then(res => {
            this.repeatSave = false;
            if (res.data.success) {
              this.$message.success(this.form.merchantTaxRefundCompanyId ? '修改成功' : '创建成功');
              this.dialogVisible = false;
              this.getTableData();
            } else {
              this.$message.error(res.data.data || res.data.message);
            }
          }).catch((err) => {
            this.repeatSave = false;
          })
        } else {
          this.$message.error('请完善信息');
          return false;
        }
      });
    },
    valiTaxRefundRatio(rule, value, callback) {
      if (!/^\d+(\.\d{1,2})?$/.test(value)) {
        callback(new Error('仅允许输入大于等于0小于等于100的数字，请修改'));
      } else if (Number(value) < 0 || Number(value) > 100) {
        callback(new Error('仅允许输入大于等于0小于等于100的数字，请修改'));
      } else {
        callback();
      }
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
.upload-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 15px;
  padding-bottom: 25px;
  color: #999;
  font-size: 12px;
  line-height: 1;

  .icon {
    color: #aaa;
    font-size: 50px;
  }
  .mt10 {
    margin-top: 10px;
  }
  .mt20 {
    margin-top: 20px;
  }
}
</style>
<style lang="less">
.upload-el {
  .el-upload--text {
    display: block;
  }
  .el-upload-dragger {
    width: auto;
    height: auto;
  }
  .el-icon-upload {
    margin: 0;
  }
}
</style>
